<div [ngStyle]="{'border-left':getColor(diaryEvent)}" (click)="clicked($event)" class="diary-event-details-list ui-g">
  <div class="diary-event-title ui-g">
    <div class="diary-event-heading-text ui-g-3">
      <span>{{getDetailTypeText()}}</span>
    </div>
    <div class="diary-event-heading-date-passed-text ui-g-9 text-right">
      <span>{{getEventStatusText()}}</span>
    </div>
    <div>
      <span class="diary-event-details-list-value">{{diaryEvent.EventTypeDescription}}</span>
    </div>
  </div>
  <div class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">For</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.ClientRef">
      <div class="diary-event-details-list-title  ui-g-9">Client Reference: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.ClientRef}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.PropertyRef">
      <div class="diary-event-details-list-title ui-g-9">Property Reference: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.PropertyRef}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.UnitRef">
      <div class="diary-event-details-list-title ui-g-9">Unit Reference: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.UnitRef}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.HeadLeaseRef">
      <div class="diary-event-details-list-title ui-g-9">Head Lease Reference: </div>
      <div class="diary-event-details-list-value  ui-g-3">{{diaryEvent.HeadLeaseRef}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.LeaseRef">
      <div class="diary-event-details-list-title ui-g-9">Lease Reference: </div>
      <div class="diary-event-details-list-value ui-g-3 ">{{diaryEvent.LeaseRef}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.TenantRef">
      <div class="diary-event-details-list-title ui-g-9">Tenant Reference: </div>
      <div class="diary-event-details-list-value ui-g-3 ">{{diaryEvent.TenantRef}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.TenantName">
      <div class="diary-event-details-list-title ui-g-6">Tenant Name: </div>
      <div class="diary-event-details-list-value ui-g-5">{{diaryEvent.TenantName}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.StrungAddress">
      <span class="diary-event-details-list-value">{{diaryEvent.StrungAddress}}</span>
    </div>
  </div>
  <div class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Key dates</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.UndatedOption == 'Y'">
      <span class="diary-event-details-list-value">This is an undated option</span>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.UDOStartDate">
      <div class="diary-event-details-list-title ui-g-9">This event starts on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.UDOStartDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.UDOEndDate">
      <div class="diary-event-details-list-title ui-g-9">and ends on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.UDOEndDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="!diaryEvent.UDOStartDate">
      <div class="diary-event-details-list-title ui-g-9">This event will happen on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.EventDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.NoticeDate">
      <div class="diary-event-details-list-title ui-g-9">Notice is to be given by: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.NoticeDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.BringForwardDate">
      <div class="diary-event-details-list-title ui-g-9">Can be brought forward on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.BringForwardDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.DateCompleted">
      <div class="diary-event-details-list-title ui-g-9">This was completed on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.DateCompleted | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.MinNoticePeriod && diaryEvent.MinNoticePeriodType">
      <div class="diary-event-details-list-title ui-g-9">Min notice: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.MinNoticePeriod}} {{diaryEvent.MinNoticePeriodType}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.NoticePeriod && diaryEvent.NoticePeriodType">
      <div class="diary-event-details-list-title ui-g-9">Max notice: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.NoticePeriod}} {{diaryEvent.NoticePeriodType}}</div>
    </div>

  </div>
  <div *ngIf="isReview()" class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Further details</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.TypeOfReview">
      <div class="diary-event-details-list-title ui-g-9">The type for this review is: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.TypeOfReview}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.StopRaisingCharges">
      <div class="diary-event-details-list-title ui-g-9">Charges will no longer be raised: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.StopRaisingCharges === 'Y' ? 'Yes' : 'No'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.TimeOfTheEssence">
      <div class="diary-event-details-list-title ui-g-9">Time of Essence clause applicable: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.TimeOfTheEssence === 'Y' ? 'Yes' : 'No'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.CounterNoticeBy">
      <div class="diary-event-details-list-title ui-g-9">Counter notice required by: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.CounterNoticeBy | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.CounterNoticeServedDate">
      <div class="diary-event-details-list-title ui-g-9">Counter noticed served on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.CounterNoticeServedDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.RicsApplicationByDate">
      <div class="diary-event-details-list-title ui-g-9">RICS application required by: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.RicsApplicationByDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.RicsApplicationMadeDate">
      <div class="diary-event-details-list-title ui-g-9">RICS application made on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.RicsApplicationMadeDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.SolicitorsConfirmedDate">
      <div class="diary-event-details-list-title ui-g-9">Solicitors confirmed on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.SolicitorsConfirmedDate | date:'dd MMM yyyy'}}</div>
    </div>
  </div>

  <div *ngIf="isExpiry()" class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Further details</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.RaiseChargesToDate">
      <div class="diary-event-details-list-title ui-g-9">Charges raised to: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.RaiseChargesToDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item">
      <div class="diary-event-details-list-title ui-g-9">This expiry is{{diaryEvent.HoldingOver == 'Y' ? '' : ' not'}} Holding Over</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.LegalExpiryDate">
      <div class="diary-event-details-list-title ui-g-9">Legal Expiry date is on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.LegalExpiryDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.Section40ServedDate">
      <div class="diary-event-details-list-title ui-g-9">Section 40 served on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.Section40ServedDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.Section25ServedDate">
      <div class="diary-event-details-list-title ui-g-9">Section 25 served on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.Section25ServedDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.CounterNoticeReceivedDate">
      <div class="diary-event-details-list-title ui-g-9">Counter notice received on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.CounterNoticeReceivedDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.Section26ServedDate">
      <div class="diary-event-details-list-title ui-g-9">Section 26 received on: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.Section26ServedDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.ContinuationTenancyDate">
      <div class="diary-event-details-list-title ui-g-9">Tenancy continuation date: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.ContinuationTenancyDate | date:'dd MMM yyyy'}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.TacitRelocationDate">
      <div class="diary-event-details-list-title ui-g-9">Tacit Relocation date is: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.TacitRelocationDate | date:'dd MMM yyyy'}}</div>
    </div>
  </div>


  <div *ngIf="isOption()" class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Further details</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.OptionBy">
      <div class="diary-event-details-list-title ui-g-9">This option is to be initiated by: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.OptionBy}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.OpenLease">
      <div class="diary-event-details-list-title ui-g-9">This relates to an '{{diaryEvent.OpenLease == 'Y' ? 'Open' : 'Closed'}}' lease</div>
    </div>
  </div>

  <div *ngIf="isReview()" class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Rent review</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.NewRent">
      <div class="diary-event-details-list-title ui-g-9">The new rent amount is: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.NewRent | number : '1.2-2'}} {{diaryEvent.CurrencyCode}}</div>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.ForecastRent">
      <div class="diary-event-details-list-title ui-g-9">Forecasted rent amount is: </div>
      <div class="diary-event-details-list-value ui-g-3">{{diaryEvent.ForecastRent | number : '1.2-2'}} {{diaryEvent.CurrencyCode}}</div>
    </div>
  </div>

  <div *ngIf="isOption() || isReview() || isExpiry()" class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Job reference for fees</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.FeeJobReference">
      <span class="diary-event-details-list-value">{{diaryEvent.FeeJobReference}}</span>
    </div>
  </div>

  <div class="diary-event-details-list-section">
    <div class="diary-event-details-list-section-header">Notes</div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.Note">
      <span class="diary-event-details-list-value">{{diaryEvent.Note}}</span>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.ReviewNote">
      <span class="diary-event-details-list-value">{{diaryEvent.ReviewNote}}</span>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.OptionNote">
      <span class="diary-event-details-list-value">{{diaryEvent.OptionNote}}</span>
    </div>
    <div class="diary-event-details-list-item" *ngIf="diaryEvent.ExpiryNote">
      <span class="diary-event-details-list-value">{{diaryEvent.ExpiryNote}}</span>
    </div>
    <div class="diary-event-details-list-item" *ngIf="!diaryEvent.ExpiryNote && !diaryEvent.Note && !diaryEvent.ReviewNote && !diaryEvent.OptionNote">
      <span class="diary-event-details-list-value">No further notes on this event.</span>
    </div>
  </div>

  <div class="diary-event-details-list-footer">
    <a>See less...</a>
  </div>
</div>
